export type MemberSaving = {
	Services: string;
	Saving: number;
};

const fiveStarServiceTitles = ['Remove & Recycle', 'Unpack'];

export function getMemberSaving(
	servicesContent: ServiceContent[]
): MemberSaving {
	const fiveStarServices = servicesContent.filter((s) => s.memberSaving > 0);
	const services = fiveStarServices.map((s) => s.title).join(', ');

	const saving = fiveStarServices
		.map((s) => s.memberSaving)
		.reduce((a, b) => a + b, 0);

	return {
		Services: services,
		Saving: saving,
	};
}

export function isFiveStarService(serviceTitle: string) {
	return fiveStarServiceTitles.includes(serviceTitle);
}
